<template>
    <v-app id="inspire">
        <v-app-bar
                v-if="loggedIn"
                app
                color="white"
                flat
        >
            <v-container class="py-0 fill-height">
                <v-row>

                    <v-tabs>
                        <v-tab
                                v-for="link in links"
                                :key="link"
                                text
                                @click="view = link"
                        >
                            {{ link }}
                        </v-tab>
                        <v-spacer></v-spacer>

                        <v-btn
                                class="ml-4"
                                icon
                                @click="logout">
                            <v-icon>mdi-logout</v-icon>
                        </v-btn>
                    </v-tabs>

                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-alert
                                v-model="$store.state.alert"
                                dense
                                class="multi-line"
                                :type="$store.state.alertCode"
                                dismissible
                        >{{ $store.state.alertMsg }}
                        </v-alert>
                    </v-col>
                </v-row>
            </v-container>

        </v-app-bar>

        <v-main class="grey lighten-3">
            <v-container>
                <v-row>
                    <v-col>
                        <v-sheet
                                rounded="lg"
                        >
                            <login-view v-if="!loggedIn" @login="logIn"></login-view>
                            <search-view v-else-if="view === 'Suche'"
                                         @openDetails="openUserDetails"
                            ></search-view>
                            <user-view v-else-if="view === 'User'" @backToSearch="view = 'Suche'" :user="user"></user-view>
                            <create-user-view v-else-if="view === 'Testnutzer erstellen'"></create-user-view>
                            <all-steps-view v-else-if="view === 'Schritte verwalten'"></all-steps-view>
                        </v-sheet>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
    import UserView from './user/UserView'
    import SearchView from "./SearchView";
    import LoginView from './LoginView'
    import CreateUserView from "./CreateUserView";
    import AllStepsView from "./AllStepsView";
    import constants from "../constants";

    export default {
        components: {AllStepsView, CreateUserView, SearchView, UserView, LoginView},
        data: () => ({
            links: [
                'Suche',
                'Testnutzer erstellen',
                'Schritte verwalten',
                'Badges verwalten'
            ],
            view: 'Suche',
            user: null,
            loggedIn: sessionStorage.getItem('loggedIn')
        }),
        watch: {
            view() {
                this.$store.commit('disableAlert')
            },
        },
        methods: {
            logout() {
                this.$http.get(constants.LOGOUT_ENDPOINT)
                sessionStorage.removeItem('loggedIn')
                this.loggedIn = false;
            },
            openUserDetails(user) {
                this.user = user;
                this.view = 'User'
            },
            logIn() {
                this.$store.commit('disableAlert')
                this.loggedIn = sessionStorage.getItem('loggedIn')
            }
        },
    }
</script>

<style>
    .multi-line {
        white-space: pre-line;
    }
</style>
